/**
 * Certification Controller
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Aditya
 */
angular.module('flsControllers').controller('CertificationController', ['$scope','$window', '$http', 'Certification',
    function($scope, $window, $http, Certification){

    // Set the Loading state
    $scope.loading = false;

    // Set initial number of Certifications
    $scope.certifications = [];

    // Init the Context
    $scope.context = {};

    // Init the Controller with the Context Type and ID
    $scope.init = function(context_type, context_id) {
        // Set loading state to true
        $scope.loading = true;

        // Compile the Context
        $scope.context = {
            context_type:context_type,
            context_id:context_id
        };

        // Load the certification in context
        $scope.loadCertifications($scope.context);
    }

    // Refresh the Certifications
    $scope.loadCertifications = function($context){
        Certification.get($context, function(resource){
            if(resource){
                $scope.certifications = resource.data;
            } else {
                /*display an error maybe? */
            };
        });
        // Set loading state to false
        $scope.loading = false;
    }

    // Add the resurce
    $scope.addCertification = function(form){
        // Match context
        var context = $scope.context;

        // Merge with Form
        var newCertification = angular.extend({}, context);

        // Set loading state to false
        $scope.loading = true;

        // Send store call
        Certification.save(newCertification, function(response){
            if(response){
                // Re-Load the certification in context
                $scope.loadCertifications(context);
            } else {

                // Set loading state to false
                $scope.loading = false;
            };
        });
    }

    // Remove the Resource
    $scope.deleteCertification = function(id){
        // Set loading state to true
        $scope.loading = true;

        // iterate through scope.certifications to find the one with ID
        angular.forEach($scope.certifications, function(certification, index) {
            if(id === certification.id) {
                // Send destroy call (via POST with additional field, '_method' = 'DELETE')
                Certification.delete({id:id}, function(response){
                    // Upon success, remove the element from the $scope.certifications
                    if(response){
                        // Load the certifications in context
                        $scope.loadCertifications($scope.context);
                    } else {
                        // Set loading state to false
                        $scope.loading = false;
                    };
                });
            }
        });
    }

}]);
